// Shared pill/button color classes - avoids Tailwind purge issues.
// Used by PillSelector and any component that maps option values to colors.
export const COLOR_CLASSES = {
  emerald: {
    sel: "bg-emerald-500 text-white border-emerald-500",
    unsel: "bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100",
  },
  blue: {
    sel: "bg-blue-500 text-white border-blue-500",
    unsel: "bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100",
  },
  amber: {
    sel: "bg-amber-500 text-white border-amber-500",
    unsel: "bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100",
  },
  red: {
    sel: "bg-red-500 text-white border-red-500",
    unsel: "bg-red-50 text-red-700 border-red-200 hover:bg-red-100",
  },
  slate: {
    sel: "bg-slate-600 text-white border-slate-600",
    unsel: "bg-slate-50 text-slate-600 border-slate-200 hover:bg-slate-100",
  },
};

// Learning Skills / Work Habits color map: grade letter → COLOR_CLASSES key
export const LSWH_COLOR_MAP = { E: "emerald", G: "blue", S: "amber", N: "red" };
